import Requests from "@/services/Requests";

const state = {
  companies: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  companyById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of companies based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter companies by. Defaults to 0.
   * @return {Array} An array of companies filtered by the given page number. If page is 0, returns all companies.
   */
  getCompanies:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.companies.data
        : state.companies.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getCompanyStatus: (state) => state.companies.status,
  getCompanyCount: (state) => state.companies.count,
  getCompanyPage: (state) => state.companies.page,
  getCompaniesLoading: (state) => state.companies.status === "loading",
  getCompanyById: (state) => (id) =>
    state.companyById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the company in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the company.
   */
  SET_COMPANY_STATUS(state, payload) {
    console.log(state.companies, "status: ", payload);
    state.companies.status = payload;
  },
  /**
   * Sets the companies and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of companies.
   * @param {number} payload.count - The total count of companies.
   */
  SET_COMPANIES(state, payload) {
    state.companies.data = payload.items;
    state.companies.count = payload.count;
  },
  /**
   * Updates the status of the update company in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the company.
   */
  SET_UPDATE_COMPANY_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an company object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated company object.
   * @return {void}
   */
  SET_UPDATE_COMPANY(state, payload) {
    const index = state.companies.data.findIndex((d) => d.id === payload.id);
    const company = state.companies.data[index];
    state.companies.data[index] = { ...company, ...payload };
  },
  SET_CREATE_COMPANY_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new company to the list of companies in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The company object to be added.
   * @return {void}
   */
  SET_CREATE_COMPANY(state, payload) {
    state.companies.data.push(payload);
  },
  /**
   * Updates the status of the delete company in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the company.
   */
  SET_DELETE_COMPANY_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an company from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the company ID to be deleted.
   * @param {number} payload.id - The ID of the company to be deleted.
   * @return {void}
   */
  SET_DELETE_COMPANY(state, payload) {
    state.companies.data = state.companies.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_COMPANY_BY_ID_STATUS(state, payload) {
    state.companyById.status = payload;
  },
  SET_COMPANY_BY_ID(state, payload) {
    state.companyById.data.push(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of companies based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.searchKey - The search key.
   * @param {string} payload.query.regionId - The region ID.
   * @param {string} payload.query.companyId - The company ID.
   * @param {number} payload.query.page - The page number.
   * @return {Promise<void>}
   */
  async getCompanies({ state, commit }, payload) {
    // if query param is not in payload or if there is already data with same page number, don't fetch again
    if (
      !["search"].some((key) => payload.query[key]) &&
      state.companies.data.filter(
        (company) => company.page === payload.query.page
      ).length > 0
    )
      return;
    commit("SET_COMPANY_STATUS", "loading");
    const response = await Requests.Company.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_COMPANIES", {
        items: response.data.items.map((item) => ({
          ...item,
          page: payload.query.page,
        })),
        count: response.data.count,
      });
    }
    commit("SET_COMPANY_STATUS", "success");
    return response.message;
  },
};

export default { state, getters, mutations, actions };
